import React, { useEffect, useState } from 'react'
import Navbar from '../components/common/navbar'
import Hero from '../components/home/hero'
import Ticker from '../components/home/ticker'
import Highlights from '../components/home/highlights'
import Affiliations from '../components/home/affilitions'
import Colleges from '../components/home/colleges'
import Notice from '../components/home/notice'
import Facility from '../components/home/facility'
import OurCourses from '../components/home/courses'
import CampusHighlights from '../components/home/campusHighlights'

import api from '../API/api'

import Footer from '../components/common/footer'


const Homepage = () => {

    useEffect(() => {
        getSchools();
    }, []);

    const [schools, setSchools] = useState();
    const [allCourse, setAllCourse] = useState();
    const [presentCourses, setPresentCourses] = useState();
    const getSchools = () => {
        api.getSchools().then((res) => {
            setSchools(res.data.schools)
            setAllCourse(res.data.allCourse)
            setPresentCourses(res.data.present_courses)
        })
            .catch((err) => {
            })
    }

    return (
        <>
            <Navbar schools={schools} />
            <Hero />
            <Ticker />
            <div className='container-fluid'>
                <Highlights />
                <Affiliations />
                <Colleges schools={schools} />
                <Notice />
                <OurCourses allCourse={presentCourses} />
                <Facility />
                <CampusHighlights />

            </div>

            <Footer />
        </>
    )
}

export default Homepage;